import { BrandMark } from "./brand-mark"

interface LoadingScreenProps {
	label: string
}

export function LoadingScreen({ label }: LoadingScreenProps) {
	return (
		<div
			className="loading-screen"
			role="status"
			aria-live="polite"
			aria-busy="true"
		>
			{/* No shadow: the mark is transparent now (the old artwork carried a
			    cream plate), so a box shadow would outline an invisible square. */}
			<BrandMark animated className="h-16 w-16" />
			<span className="sr-only">{label}</span>
		</div>
	)
}
